import type { RefObject } from 'react'
import type {
	SRT_ColumnDef,
	SRT_RowData,
	SRT_StatefulTableOptions,
} from '../../types'

import { SRT_TableBodyRowGrabHandle } from '../../components/body/SRT_TableBodyRowGrabHandle'
import { defaultDisplayColumnProps } from '../../utils/displayColumn.utils'

export const getSRT_RowDragColumnDef = <TData extends SRT_RowData>(
	tableOptions: SRT_StatefulTableOptions<TData>
): SRT_ColumnDef<TData> => ({
	Cell: ({ row, rowRef, table }) => (
		<SRT_TableBodyRowGrabHandle
			row={row}
			rowRef={rowRef as RefObject<HTMLTableRowElement | null>}
			table={table}
		/>
	),
	grow: false,
	...defaultDisplayColumnProps({
		header: 'move',
		id: 'srt-row-drag',
		size: 60,
		tableOptions,
	}),
})
